import styles from './FedorBusyScreen.module.css'
import {INTERVIEW_CHECK_UNAVAILABLE_MESSAGE, INTERVIEW_LIMIT_MESSAGE, type InterviewAdmissionFailure} from '@/src/lib/interviewAdmission'

interface FedorBusyScreenProps {
  onBack?: () => void
  reason?: InterviewAdmissionFailure
}

export function FedorBusyScreen({ onBack, reason = 'busy' }: FedorBusyScreenProps) {
  return (
    <div className={styles.container} role="alert">
      <h2 className={styles.title}>{reason === 'no_credits' ? INTERVIEW_LIMIT_MESSAGE
        : reason === 'check_unavailable' ? INTERVIEW_CHECK_UNAVAILABLE_MESSAGE : 'Простите, Федор пока занят'}</h2>
      {reason === 'busy' && <p className={styles.text}>
        Мы сохранили ваши данные. Попробуйте зайти чуть позже, и мы продолжим интервью.
      </p>}
      {onBack && (
        <button type="button" className={`${styles.button} lk-button`} onClick={onBack}>
          Вернуться
        </button>
      )}
    </div>
  )
}
